import React from 'react'
import CommunityPostsListing from './CommunityPostsListing'

const CommunityRoundWinner = () => (
  <CommunityPostsListing
    postType="round_winner"
    title="Round Winner Posts"
    subtitle="The winner announced to your community after each round."
  />
)

export default CommunityRoundWinner
